Ext.define('SA.AjaxTimeoutSignal', {
    singleton: true,

    get(duration) {
        var controller = new AbortController();

        setTimeout(() => controller.abort(), duration);

        return controller.signal;
    }
});